module.exports = __webpack_public_path__ + "img/288.1d301271.png";